<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Dashboard de Marketplace</h3>
        </div>
      </div>
      <d-row>
        <!-- Cards -->
        <d-col v-for="(card, index) in Cards" :key="index" md="6" lg="4" class="mb-4">
          <cards :id="`card-${index}`" :link="card.link" :label="card.label" :value="card.value" />
        </d-col>
      </d-row>
      <div v-if="loading">
        <loader :is-loading="loading" />
      </div>
      <div class="row equal-cols" v-else>
        <d-col class="mb-4 col-lg-6 lg-s">
          <d-row
            v-if="this.infoDashboard.MerchantsMarketplace != null && this.infoDashboard.MerchantsMarketplace.length > 0"
          >
            <d-col class="mb-12 col-lg-12 lg-s">
              <d-card class="card-small">
                <!-- Card Header -->
                <d-card-header class="border-bottom">
                  <div class="float-left">
                    <h6 class="m-0">Top 10 Marketplaces</h6>
                  </div>
                  <div class="float-right">
                    <i class="fas fa-dollar-sign"></i>
                  </div>
                </d-card-header>
                <d-card-body class="p-0">
                  <!-- Services List Group -->
                  <d-list-group flush class="list-group-small">
                    <d-list-group-item
                      v-for="(item, index) in this.infoDashboard.MerchantsMarketplace"
                      :key="index"
                      class="d-flex px-3"
                    >
                      <i
                        v-if="item.Position > 0 && item.Position < 4"
                        :class="['fas fa-medal mt-1 mr-2 padding-right-item', GetIconColorClass(item.Position)]"
                      ></i>
                      <span
                        v-if="item.Position > 3"
                        class="text-semibold text-nowrap text-fiord-blue ml-1 padding-right-item"
                      >{{ item.Position }}</span>
                      <span
                        :title="item.Merchant.Name"
                        v-b-tooltip.hover.bottom
                        class="text-semibold text-nowrap text-fiord-blue text-ellipsis"
                      >{{ item.Merchant.Name}}</span>
                      <span
                        class="ml-auto text-nowrap text-right text-semibold padding-left-item"
                      >{{ item.Amount | currency }}</span>
                    </d-list-group-item>
                  </d-list-group>
                </d-card-body>
                <d-card-footer class="border-top">
                  <d-row>
                    <!-- Footer -->
                    <d-col class="text-right view-report">
                      <a
                        class="go-stats__meta"
                        href="#"
                        v-on:click="OpenMarketplaces($event)"
                      >Ver todos</a>
                      <button
                        class="btn button-arrow"
                        type="button"
                        v-on:click="OpenMarketplaces($event)"
                      >
                        <i class="fas fa-angle-down"></i>
                      </button>
                    </d-col>
                  </d-row>
                </d-card-footer>
              </d-card>
            </d-col>
          </d-row>
          <br />
        </d-col>
        <d-col class="mb-4 col-lg-6 lg-s">
          <d-row
            v-if="this.infoDashboard.MerchantsMarketplaceSub != null && this.infoDashboard.MerchantsMarketplaceSub.length > 0"
          >
            <d-col class="mb-12 col-lg-12 lg-s">
              <d-card class="card-small">
                <!-- Card Header -->
                <d-card-header class="border-bottom">
                  <div class="float-left">
                    <h6 class="m-0">Top 10 Subcontas</h6>
                  </div>
                  <div class="float-right">
                    <i class="fas fa-dollar-sign"></i>
                  </div>
                </d-card-header>
                <d-card-body class="p-0">
                  <!-- Services List Group -->
                  <d-list-group flush class="list-group-small">
                    <d-list-group-item
                      v-for="(item, index) in this.infoDashboard.MerchantsMarketplaceSub"
                      :key="index"
                      class="d-flex px-3"
                    >
                      <i
                        v-if="item.Position > 0 && item.Position < 4"
                        :class="['fas fa-medal mt-1 mr-2 padding-right-item', GetIconColorClass(item.Position)]"
                      ></i>
                      <span
                        v-if="item.Position > 3"
                        class="text-semibold text-nowrap text-fiord-blue ml-1 padding-right-item"
                      >{{ item.Position }}</span>
                      <span
                        :title="item.Merchant.Name + ' (' + item.MerchantRoot.Name + ')'"
                        v-b-tooltip.hover.bottom
                        class="text-semibold text-nowrap text-fiord-blue text-ellipsis"
                      >{{ item.Merchant.Name }} ({{item.MerchantRoot.Name}})</span>
                      <span
                        class="ml-auto text-nowrap text-right text-semibold padding-left-item"
                      >{{ item.Amount | currency }}</span>
                    </d-list-group-item>
                  </d-list-group>
                </d-card-body>
                <d-card-footer class="border-top">
                  <d-col class="text-right view-report">
                    <button
                      class="btn button-arrow-hidden"
                      type="button"
                    >
                      <i class="fas fa-angle-down"></i>
                    </button>
                  </d-col>
                </d-card-footer>
              </d-card>
            </d-col>
          </d-row>
          <br />
        </d-col>
      </div>
    </div>
    <a
      href="#"
      class="btn-float btn-primary"
      v-show="showBtnScroll"
      v-on:click="ScrollToTop($event)"
    >
      <i class="fa fa-chevron-up"></i>
    </a>
  </div>
</template>

<script>
import cards from "@/components/common/cards";
export default {
  name: "marketplace-dashboard",
  components: {
    cards
  },
  data: function() {
    return {
      loading: false,
      infoDashboard: {
        QuantityMarketplace: 0,
        QuantityMarketplaceSub: 0,
        QuantityMarketplaceProfit: 0,
        QuantityMarketplaceSubProfit: 0,
        MerchantsMarketplace: []
      },
      showBtnScroll: false
    };
  },
  created() {
    window.addEventListener("scroll", this.HandleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.HandleScroll);
  },
  computed: {
    Cards() {
      return [
        {
          label: "Marketplaces",
          value:
            this.$options.filters
              .number(this.infoDashboard.QuantityMarketplaceProfit)
              .toString() +
            "/" +
            this.$options.filters
              .number(this.infoDashboard.QuantityMarketplace)
              .toString()
        },
        {
          label: "Subcontas",
          value:
            this.$options.filters
              .number(this.infoDashboard.QuantityMarketplaceSubProfit)
              .toString() +
            "/" +
            this.$options.filters
              .number(this.infoDashboard.QuantityMarketplaceSub)
              .toString()
        },
        {
          label: "Total",
          value:
            this.$options.filters
              .number(
                this.infoDashboard.QuantityMarketplaceProfit +
                  this.infoDashboard.QuantityMarketplaceSubProfit
              )
              .toString() +
            "/" +
            this.$options.filters
              .number(
                this.infoDashboard.QuantityMarketplace +
                  this.infoDashboard.QuantityMarketplaceSub
              )
              .toString()
        }
      ];
    }
  },
  watch: {},
  mounted() {
    this.GetMarketplaceDashboard();
    this.$root.$on("bv::tooltip::show", bvEvent => {
      if (bvEvent.target.offsetWidth == bvEvent.target.scrollWidth)
        bvEvent.preventDefault();
    });
  },
  methods: {
    GetIconColorClass: function(position) {
      let colorClass;
      if (position == 1) {
        colorClass = "icon-gold";
      } else if (position == 2) {
        colorClass = "icon-silver";
      } else if (position == 3) {
        colorClass = "icon-bronze";
      }
      return colorClass;
    },
    GetMarketplaceDashboard: function() {
      this.loading = true;
      this.$store
        .dispatch("GetMarketplaceDashboard")
        .then(response => {
          this.infoDashboard = response;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o Dashboard",
            error
          );
        })
        .finally(() => (this.loading = false));
    },
    OpenMarketplaces: function(e, i) {
      e.preventDefault();
      this.$router.push({
        name: "marketplaces"
      });
    },
    HandleScroll: function() {
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400
      ) {
        this.showBtnScroll = true;
      } else {
        this.showBtnScroll = false;
      }
    },
    ScrollToTop: function() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style scoped>
.button-arrow {
  padding: 0px;
}
.button-arrow-hidden {
  padding: 0px;
  visibility: hidden;
}
.padding-right-item {
  padding-right: 10px;
}
.padding-left-item {
  padding-left: 35px;
}
.icon-gold {
  color: #edd05c;
}
.icon-silver {
  color: #9ea5b5;
}
.icon-bronze {
  color: #e09848;
}
</style>
<style>
.tooltip-inner {
  font-size: 10pt;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/marketplaceDashboard.vue